import Component from 'react-pure-render/component';
import { connect } from 'react-redux';
import { List } from 'immutable';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import * as actions from '../Actions.js';
import DateUtils from 'portaltransparencia-common/libs/DateUtils';
import NumberFormatter from 'portaltransparencia-common/components/NumberFormatter.react';
import React from 'react';
import TableActions from 'portaltransparencia-common/components/TableActions.react';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react';
import SearchPagination from 'portaltransparencia-common/components/SearchPagination.react';

const ACTIVE_TAB_POR_ROTINA = {
  Liquidação: 'liquidacoes',
  Pagamento: 'pagamentos',
  Retenção: 'retencoes',
  Empenho: 'movimentacao',
  'Anulação Empenho': 'anulacoes',
  'Anulação Liquidação': 'movimentacao',
  'Estorno Pagamento': 'movimentacao'
};

export class FormDetailMovimentacoes extends Component {
  static propTypes = {
    pageMovimentacao: PropTypes.object.isRequired,
    findMovimentacao: PropTypes.func.isRequired,
    idEmenda: PropTypes.number.isRequired,
    history: PropTypes.object.isRequired
  };

  componentDidMount() {
    this.searchWithPage(
      this.props.pageMovimentacao.set('number', 0).set('size', 20)
    );
  }

  searchWithPage = page => {
    const { findMovimentacao, idEmenda } = this.props;
    findMovimentacao(idEmenda, page);
  };

  hasEmpenho = movimentacao => {
    return (
      movimentacao.get('numeroEmpenho') &&
      movimentacao.get('exercicioEmpenho') &&
      movimentacao.get('entidadeEmpenho')
    );
  };

  onViewEmpenho = movimentacao => {
    const entidade = movimentacao.get('entidadeEmpenho');
    const exercicio = movimentacao.get('exercicioEmpenho');
    const empenho = movimentacao.get('numeroEmpenho');

    let url = `/empenhos/detalhe?search=id.entidade==${entidade}&entidade=${entidade}&exercicio=${exercicio}&empenho=${empenho}`;

    const active = ACTIVE_TAB_POR_ROTINA[movimentacao.get('rotina')];
    if (active) {
      url += `&active=${active}`;
    }

    this.props.history.push(url);
  };

  renderRow = (movimentacao, index) => {
    return (
      <TableActions
        key={index}
        data={movimentacao}
        onMore={this.hasEmpenho(movimentacao) ? this.onViewEmpenho : undefined}
      >
        <td>{DateUtils.formatDateTimeShort(movimentacao.get('data'))}</td>
        <td>{movimentacao.get('rotina')}</td>
        <td>{movimentacao.get('numeroDocumento')}</td>
        <td className="right">
          <NumberFormatter value={movimentacao.get('valor')} />
        </td>
      </TableActions>
    );
  };

  render() {
    const { pageMovimentacao } = this.props;
    const content = pageMovimentacao.get('content', List());

    return (
      <div>
        {content.size > 0 ? (
          <table className="panel-table striped fancy">
            <TableHeader empty={content.isEmpty()}>
              <tr>
                <th>Data</th>
                <th>Rotina</th>
                <th>Documento</th>
                <th style={{ textAlign: 'right' }}>Valor</th>
                <th />
              </tr>
            </TableHeader>
            <tbody>{content.map(this.renderRow)}</tbody>
          </table>
        ) : (
          <div className="empty-state">Nenhuma movimentação encontrada.</div>
        )}
        <SearchPagination
          page={pageMovimentacao}
          searchWithPage={this.searchWithPage}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    pageMovimentacao: state.emendaContabilidade.get('movimentacoes')
  };
}

const allActions = {
  findMovimentacao: actions.findMovimentacao
};

export default connect(
  mapStateToProps,
  allActions
)(withRouter(FormDetailMovimentacoes));
